import React from "react";
import "assets/demo/iconosFlotantes.css";

function Whatsapp() {
  return (
    <a
      href="https://wa.me/573054407547"
      className="float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
    >
      <i className="fa fa-whatsapp my-float"></i>
    </a>
  );
}

export default Whatsapp;
